import { gql } from "apollo-boost"


export const generalPeopleGetStories = gql`
  query GeneralPeopleGetStories($subjectId: ID, $country: String!){
    generalGetStories(subjectId: $subjectId, country: $country ){
      id
      name
      photo
      seen
      lastUpdated
      userProfileUrl
      items{
        id
        fileType
        length
        src
        preview
        link
        linkText
        time
        seen
        subject
      }
    }
  }
`

export const authUsersGetStories = gql`
  query AuthUsersGetStories($subjectId: ID, $country: String!){
    getStories(subjectId: $subjectId, country: $country){
      id
      name
      photo
      seen
      lastUpdated
      userProfileUrl
      items{
        id
        fileType
        length
        src
        preview
        link
        linkText
        time
        seen
        subject
      }
    }
}
`

export const makeStoryAsRead = gql`
  mutation MakeStoryAsRead($id: ID!){
    storySeen(id: $id)
  }
`

export const userGetHistStories = gql`
query{
  getHisStories{
    id
    name
    photo
    seen
  	lastUpdated
  	items{
      id
  	  fileType
  		length
  		src
  		preview
  		link
  		linkText
  		time
    	seen
      subject
    }
  }
}
`

export const uploadStoriesMedia = gql`
  mutation upload($file: Upload!){
    uploadStoryMedia(file: $file){
      fileName 
      path
      durationSecs
      mimeType 
    }
  }
`

export const userCreateNewStory = gql`
  mutation CreateNewStory( $data: createStoryInput!){
    createNewStory(data: $data){
      id
     fileType
     length
     src
     preview
     link
     linkText
     time
     seen
     subject
    }
  }
`

export const getAllDeletedStories = gql`
  query{
    getHighlightStories{
      id
      src
    }
  }
`

export const createNewHighlightGroup = gql`
  mutation CreateNewHighlightGroup($data: createHighlightGroupInput!){
    createHighlightGroup(data: $data){
      id
      groupTitle
      photo
      seen
      lastUpdated
      stories {
        id
        fileType
        length
        src
        link
        seen
        subject
      }
    }
  }
`

export const tutorGetHisHightlightGroups = gql`
  query{
    getHighlightGroups{
             id
        groupTitle
        photo
        seen
        lastUpdated
        stories {
            id
            fileType
            length
            src
            link
            seen
            subject
        }   
    }
}
`

export const deleteUserHighlight = gql`
  mutation DeleteUserHighlight($groupId: Int!){
    deleteHighlightGroup(groupId: $groupId)
  }
`


export const publicGetHighlightStoriesGroups = gql`
  query PublicGetHighlightGroups($userId:Int!){
    publicGetHighlightGroups(userId: $userId){
        id
        groupTitle
        photo
        seen
        lastUpdated
        stories {
            id
            fileType
            length
            src
            link
            seen
            subject
        }   
    }
  }
`